
(function () {
  'use strict';

  class CalendarListItemComponent extends Controllers.BaseControllerES6 {

    // @ngInject
    constructor($scope, $injector, UIUtils) {
      super($scope, $injector);
      this.__objectType = 'CalendarListItemComponent';
      this.UIUtils = UIUtils;
    }
  }

  Components.CalendarListItem = {
    bindings: {
      color: '@',
      cssClass: '@',
      toggleCheckbox: '&',
      analyticsCheckboxEvent: '@',
      analyticsCheckboxProps: '@',
      checkboxActive: '=',
      label: '@',
      staticList: '='
    },
    controller: CalendarListItemComponent,
    name : 'hbCalendarListItem',
    templateUrl: 'angular/app/modules/core/features/calendar/calendar_list/calendar_list_item.html',
  };

}());

